import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window['logs'] = [];
  console.log   = (e) => { window['logs'].push({log: e}) }
  console.error = (e) => { window['logs'].push({error: e}) }
  console.warn  = (e) => { window['logs'].push({warn: e}) }
}

platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts